<template>
    <ModalComponent
        :name="name"
        title="Descargar abonados"
        v-on:close="() => close(false)"
    >
        <template>            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <Button @click="getAbonados()">DESCARGAR</Button>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['name', 'searchParams'],
    data() {
        return {
            loading: false
        }
    },
    methods: {
        close() {
            this.$emit('close', this.name);
        },
        getAbonados() {
            this.loading = true;
            delete this.searchParams.filters.per_page;
            delete this.searchParams.filters.page;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.abonos.descargar_excel'), this.searchParams).then(res => {
                this.$toast.success(res.data.message);
            });
        }
    },
    components: {
        ModalComponent
    }
}
</script>
